import "./menu.css";
import React, { useState } from 'react';
import ReferralPopup from '../referral-popup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faAddressBook,
    faCoins,
    faCreditCard,
    faFileLines,
    faLifeRing,
    faLightbulb,
    faPaperPlane,
    faReceipt,
    faRightLeft
} from '@fortawesome/free-solid-svg-icons';

//VISUALS
import LOGO from '../../assets/images/full_dark.png';

//TRANSLATION
import { useTranslation } from 'react-i18next';

const Menu = () => {
    const currentPath = window.location.pathname;
    const { t } = useTranslation();
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    const handleJoinMeClick = () => {
        setIsPopupOpen(true);
    };

    const closePopup = () => {
        setIsPopupOpen(false);
    };

    return (
        <>
            <div className="left_menu">
                <img src={LOGO} alt="Lifise logo" className="logo" />
                <a href={"/dashboard"} className={currentPath === "/dashboard" ? "entry active mt-50" : "entry mt-50"}>
                    <span className="icon"><FontAwesomeIcon icon={faCreditCard} /></span> {t('menu.my_account')}
                </a>
                <a href={"/transfers"} className={currentPath === "/transfers" ? "entry active" : "entry"}>
                    <span className="icon"><FontAwesomeIcon icon={faRightLeft} /></span> {t('menu.transfer_funds')}
                </a>
                <a href={"/operations"} className={currentPath === "/operations" ? "entry active" : "entry"}>
                    <span className="icon"><FontAwesomeIcon icon={faReceipt} /></span> {t('menu.operations')}
                </a>
                <a href={"/beneficiaries"} className={currentPath === "/beneficiaries" ? "entry active" : "entry"}>
                    <span className="icon"><FontAwesomeIcon icon={faAddressBook} /></span> {t('menu.beneficiaries')}
                </a>
                <a href={"#airdrop"} onClick={() => window.open("https://deck.lifise.io")} className={currentPath === "/airdrop" ? "entry active" : "entry"} >
                    <span className="icon"><FontAwesomeIcon icon={faCoins} /></span> Private Sale Caâm
                </a>
                <a href={"#use_cases"} onClick={() => window.open("https://lifise.io/use-case-rwa")} className={currentPath === "/sponsor" ? "entry active" : "entry"}>
                    <span className="icon"><FontAwesomeIcon icon={faLightbulb} /></span> {t('menu.use_cases')}
                </a>
                <a href={"#whitepaper"} onClick={() => window.open("https://livreblanc.lifise.io/")} className={currentPath === "/sponsor" ? "entry active" : "entry"}>
                    <span className="icon"><FontAwesomeIcon icon={faFileLines} /></span> Whitepaper
                </a>
                <a href={"/assistance"} className={currentPath === "/assistance" ? "entry active" : "entry"}>
                    <span className="icon"><FontAwesomeIcon icon={faLifeRing} /></span> {t('menu.assistance')}
                </a>
                <div className="share">
                    {navigator.share && <React.Fragment>
                        <div className="rocket">
                            <FontAwesomeIcon icon={faPaperPlane} />
                        </div>
                        <p className="center">
                            {t('menu.send_link')}
                            <br />
                            {t('menu.join_you')}
                        </p>
                        <button className="action" onClick={handleJoinMeClick}>
                            {t('menu.share')}
                        </button>
                    </React.Fragment>}
                </div>
            </div>
            <div className="mobile_menu">
                <div className={currentPath === "/dashboard" ? "entry realigned active" : "entry realigned"} onClick={() => window.location.href = "/dashboard"}>
                    <FontAwesomeIcon icon={faCreditCard} />
                </div>
                <div className={currentPath === "/transfers" ? "entry realigned active" : "entry realigned"} onClick={() => window.location.href = "/transfers"}>
                    <FontAwesomeIcon icon={faRightLeft} />
                </div>
                <div className={currentPath === "/operations" ? "entry realigned active" : "entry realigned"} onClick={() => window.location.href = "/operations"}>
                    <FontAwesomeIcon icon={faReceipt} />
                </div>
                <div className={currentPath === "/beneficiaries" ? "entry realigned active" : "entry realigned"} onClick={() => window.location.href = "/beneficiaries"}>
                    <FontAwesomeIcon icon={faAddressBook} />
                </div>
                <div className={currentPath === "/assistance" ? "entry realigned active" : "entry realigned"} onClick={() => window.location.href = "/assistance"}>
                    <FontAwesomeIcon icon={faLifeRing} />
                </div>
            </div>
            <ReferralPopup isOpen={isPopupOpen} onClose={closePopup} />
        </>
    );
};

export default Menu;